
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import GET_TITLES from "@/apollo/autocomplete-queries/GetTitlesNew.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import {Query_RootUser_ProfileArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      titles: {
        query: GET_TITLES,
        variables() {
          return {
        titleSearchString: `%${this.titleSearchString}%`, 
        limit: 10,
      };
        },
        update(data) {
          const profiles = data.user;
  const results = [];

  // handle the user_experience
  if (data.user_experience.length > 0) {
    data.user_experience.forEach(experience => {
      let experienceJobTitle = null;
      experienceJobTitle = experience.job_title;
      if (experienceJobTitle) {
        results.push({ id: experienceJobTitle, name: experienceJobTitle });
      }
    });
  }

  // handle the user_profile_by_management
  if (data.user_profile_by_management.length > 0) {
    data.user_profile_by_management.forEach(management => {
      let experienceJobTitle = null;
      experienceJobTitle = management.job_title;
      if (experienceJobTitle) {
        results.push({ id: experienceJobTitle, name: experienceJobTitle });
      }
    });
  }

  // handle the user_profile
  if (data.user_profile.length > 0) {
    data.user_profile.forEach(profile => {
      let experienceJobTitle = null;
      experienceJobTitle = profile.job_title;
      if (experienceJobTitle) {
        results.push({ id: experienceJobTitle, name: experienceJobTitle });
      }
    });
  }
  const uniqueResults = [];
      const seenNames = new Set();

        results.forEach((result) => {
        const existingNames = uniqueResults.map((res) => res.name);
        const isDuplicate = existingNames.includes(result.name);

        if (!isDuplicate) {
          uniqueResults.push(result);
        }
      });
      return uniqueResults;
        },
        skip() {
          return !this.titleSearchString;
        },
      },
    },
  })

  export default class TitlesMultiselect extends Vue {
    @Prop({required: true, type: Array}) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;
    @Prop({ type: String, default: "Title" }) readonly placeholder: string;

    titles: DropdownOption[] = [];
    titleSearchString = "";

    get mappedTitleValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get titleAutocompleteFilter(): Query_RootUser_ProfileArgs {
      const conditions: any[] = [
        { 
          titleSearchString: { 
            _ilike: `%${this.titleSearchString}%`
          }, 
        },
        { 
          titleSearchString: {
            _is_null: false } 
        },
      ]; 

      if (this.mappedTitleValue.length) {
        conditions.push(
          {
            titleSearchString: { 
              _nin: this.mappedTitleValue 
            }, 
          },
        );
      }
      return {
        where: { _and: conditions },
        limit: 10,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val)
    }
  }
